import { ReactNode, useContext } from 'react'
import { AuthContext } from '../../../../contexts/AuthContext'
import Switch from '@components/ItemPage/Details/Notifications/Switch'
import Section from '@components/ItemPage/Layout/Section'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'

const ItemNotification = () => {
  const { itemState, itemHandler, modal, auction, lastUpdated } = useItemPage()
  const { enableEmail, enableSMS } = itemState

  const {
    isAuthenticated,
    userData: {
      profile: { emailNotification, smsNotification },
    },
  } = useContext<any>(AuthContext)

  if (!isAuthenticated) return <></>

  return (
    <Section title="Notifications">
      <div className="border-t-[1px] border-gray-100 py-2">
        <Switch
          label={'EMAIL'}
          name="Email"
          value={enableEmail}
          handleSwitch={itemHandler.handleSwitch}
          disabled={!emailNotification}
        />
      </div>
      <div className="border-y-[1px] border-gray-100 py-2">
        <Switch
          label={'TEXT'}
          name="SMS"
          value={enableSMS}
          handleSwitch={itemHandler.handleSwitch}
          disabled={smsNotification !== 1}
        />
      </div>
    </Section>
  )
}

export default ItemNotification
